import { H3 } from "components/ui/typography/titles/Titles"
import { Collapse } from "components/ui/collapse/Collapse"
import { useObjectCategoryDrawerStore } from "store/configuration.store"
import style from "./CompositeCategories.module.scss"

const { compositeCategories, recipeWrapper, childrenWrapper, rowStyle, cellStyle, collapse, item } = style

export const CompositeCategories = () => {
	const { objectCategoryStore } = useObjectCategoryDrawerStore()
	console.log("objectCategoryStore :>", objectCategoryStore)

	return (
		<div className={compositeCategories}>
			<H3>Composite Categories</H3>
			<div className={recipeWrapper}>
				{objectCategoryStore.recipes?.map((recipe, index) => (
					<Collapse
						key={index}
						className={collapse}
						items={[
							{
								key: `variant-${index}`,
								label: `Combination ${index + 1}`,
								"data-testid": "collapse-items",
								children: (
									<div className={childrenWrapper}>
										{recipe.map((row, rowIndex) => (
											<div key={rowIndex} className={rowStyle}>
												{row.map((cell, cellIndex) => (
													<div key={cellIndex} className={cellStyle}>
														<div className={item}>{cell}</div>
													</div>
												))}
											</div>
										))}
									</div>
								),
							},
						]}
					/>
				))}
			</div>
		</div>
	)
}
